<div *ngIf="!showLoading" class="container-fluid">
  <div class="hero-image">
    <app-cfet-carousel></app-cfet-carousel>
    <div class="overlay-container">
      <div class="header-content">
        <header>{{cfetLabels.cfet_customer_landing.header_content}}</header>
      </div>
      <div class="eligibility-button">
        <button type="button" class="btn"
          (click)="checkEligibility($event)">{{cfetLabels.cfet_customer_landing.check_eligibility}}</button>
      </div>
    </div>
  </div>
  <app-cfet-footer></app-cfet-footer>
</div>
<app-custom-spinner *ngIf="showLoading"></app-custom-spinner>